<div>
  <mat-tab-group>
    <mat-tab label="Countdown">
      <mat-form-field class="pe-se-input">
        <mat-label>Header</mat-label>
        <input matInput
               [(ngModel)]="item.data.header">
      </mat-form-field>
      <mat-form-field class="pe-se-input">
        <mat-label>Description</mat-label>
        <textarea matInput
                  [(ngModel)]="item.data.description">
        </textarea>
      </mat-form-field>

      <mat-form-field class="pe-se-input">
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="item.data.time">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <div class="pe-se-title-input">
        When it end
      </div>
      <mat-slide-toggle class="pe-se-input" [(ngModel)]="item.data.closeTheStore">Close the store</mat-slide-toggle>

      <button  mat-raised-button color="primary" class="custom-button-closed-stored" (click)="openWindowText()">Customize text when the store closes</button>
    </mat-tab>
    <mat-tab label="Layout">
      <app-sub-layout-setting [item]="item" [layoutSetting]="layoutSetting"></app-sub-layout-setting>
    </mat-tab>
  </mat-tab-group>


</div>
